'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _transliteration = require("transliteration");
var _Routing = require("Functions/Routing");
var _utilities = require("Shared/utilities");
const _excluded = ["data", "variant", "ratio"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
class S3Image extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      id: 'image-' + ++app.images_id
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    window.objectFitImages(document.getElementById(state.id));
  }
  componentDidUpdate() {
    const component = this,
      props = this.props,
      state = this.state;
    window.objectFitImages(document.getElementById(state.id));
  }
  render() {
    const component = this,
      state = this.state;
    const _this$props = this.props,
      {
        data,
        variant,
        ratio
      } = _this$props,
      props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
    let url = data.url,
      tmp = false;
    if (data.url && (0, _utilities.isTrue)(data.renamed) === false) {
      tmp = true;
      url = (0, _Routing.action)('GetTmpImage').replace(':filename', data.filename).replace(':inline', ['image', 'pdf'].includes(data.type));
    } else if (data.public !== true && tmp === false) {
      const ext = data.url.slice(data.url.lastIndexOf('.'));
      const filename = (0, _transliteration.slugify)(data.title) + ext;
      let path = data.url.slice(0, data.url.lastIndexOf('/') + 1);
      url = path + filename;
    }
    if (variant) {
      const variant_data = (data.variants || []).find(function (infos) {
        if (ratio) {
          return variant == infos.width && ratio === infos.ratio;
        }
        return infos.width == variant;
      });
      if (variant_data) {
        url = data.public === true ? variant_data.url : url + '?v=' + variant_data.id;
      }
    }
    let output = /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
      className: props.className || 'u-responsive-img',
      id: state.id
    }, props, {
      src: url,
      alt: data.alt || data.title,
      title: data.title
    }));
    return output;
  }
}
exports.default = S3Image;
